import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-ec.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-ec.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationLocationEcConstants } from "./create-application-location-ec.constants";
import Polygon from "@arcgis/core/geometry/Polygon";
import Query from "@arcgis/core/rest/support/Query";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { AlertType } from "../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import { debounceTime } from "rxjs";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { MapTools } from "../../../../map/shared/map.tools";
let CreateApplicationLocationEcComponent = class CreateApplicationLocationEcComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    mapService;
    mapTools;
    selectedApplicationService;
    requestStatusService;
    changeDetectorRefs;
    searchApplicationsService;
    // controls
    propertiesFormGroupName = CreateApplicationLocationEcConstants.PROPERTIES_FORM_GROUP_NAME;
    erfNoControl = CreateApplicationLocationEcConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationEcConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationEcConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationEcConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationEcConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationEcConstants.ADDRESS_CONTROL;
    ownerControl = CreateApplicationLocationEcConstants.OWNER_CONTROL;
    buildingNameControl = CreateApplicationLocationEcConstants.BUILDING_NAME_CONTROL;
    floorControl = CreateApplicationLocationEcConstants.FLOOR_CONTROL;
    // Labels and placeholders
    descriptionLabel1 = CreateApplicationLocationEcConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationEcConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationEcConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationEcConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationEcConstants.VALIDATION_MESSAGES;
    erfNoTextPlaceHolder = CreateApplicationLocationEcConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationEcConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationEcConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationEcConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationEcConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationEcConstants.ADDRESS_TEXT_PLACEHOLDER;
    ownerLabel = CreateApplicationLocationEcConstants.OWNER_LABEL;
    removePropertyLabel = CreateApplicationLocationEcConstants.REMOVE_PROPERTY_LABEL;
    ownerListLabel = CreateApplicationLocationEcConstants.OWNER_LIST_LABEL;
    buildingNamePlaceHolder = CreateApplicationLocationEcConstants.BUILDING_NAME_LABEL;
    floorPlaceholder = CreateApplicationLocationEcConstants.FLOOR_LABEL;
    copyOwnerLabel = CreateApplicationLocationEcConstants.COPY_OWNER_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    applicantGroups = [];
    yesNoOptions = [];
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    ecApplication;
    propertiesForm;
    active = 0;
    mapComponent;
    isMapLoaded = false;
    selectedApplicationLocationEcSubscription;
    selectedPropertySubscription;
    clearLayerGraphicsSubjectSubscription;
    getTrueCentroidSubscription;
    applicationCreateServiceSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, appController, mapService, mapTools, selectedApplicationService, requestStatusService, changeDetectorRefs, searchApplicationsService) {
        super(createApplicationService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.mapService = mapService;
        this.mapTools = mapTools;
        this.selectedApplicationService = selectedApplicationService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.getMetadata();
        this.initForm();
        this.checkSave();
        this.subscribeToProperty();
        if (this.createApplicationService.propertyData) {
            this.createApplicationService.propertyData = null;
        }
        this.yesNoOptions = [];
        // tslint:disable-next-line:forin
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
        this.subscribeToClearMapGraphics();
        this.subscribeToCheckFormValidity();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.applicantGroups = stepMeta.applicantGroup;
        if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = false;
            this.farmNoControlRequired = false;
            this.erfNoControlRequired = true;
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") || (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = false;
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = true;
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        const previousActiveIndex = this.active;
        this.getProperties().removeAt(propertyIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
        if (previousActiveIndex === propertyIndex && propertyIndex > 0) {
            this.active = propertyIndex - 1;
        }
        else if (previousActiveIndex > propertyIndex) {
            this.active = previousActiveIndex - 1;
        }
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    onCopyOwnerToApplicant(propertyIndex) {
        const ownersControl = this.getProperties().controls[propertyIndex].get(this.ownerControl);
        const selectedOwners = ownersControl.value ? ownersControl.value.filter((x) => x.selected === true) : [];
        if (selectedOwners.length === 0) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.NO_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length > 1) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.MULTIPLE_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length === 1) {
            const applicant = RecipientUtils.buildApplicantStringForUserSettings(selectedOwners[0], this.applicantGroups);
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(applicant);
            this.appController.showMessage("Owner data successfully copied", AlertType.Success);
        }
    }
    checkSave() {
        this.selectedApplicationLocationEcSubscription = this.selectedApplicationService.$selectedApplication.subscribe(app => {
            this.ecApplication = app;
            if (this.ecApplication)
                this.syncMapExistingGeometries();
            this.changeDetectorRefs.detectChanges();
        });
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationEcConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                id: new FormControl(0),
                applicationId: new FormControl(0),
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                buildingName: new FormControl(null, [Validators.required]),
                floor: new FormControl(null, [Validators.required]),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1)]),
                owners: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
                .subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    this.getPropertyOwners(sgCode, newProperty);
                }, error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(CreateApplicationLocationEcConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                id: 0,
                                name: item.attributes.Name,
                                surname: item.attributes.Surname,
                                telephone: item.attributes.Telephone,
                                email: item.attributes.Email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod,
                                postalAddress: item.attributes.PostalAddress,
                                designation: item.attributes.Designation,
                                organisation: item.attributes.Organisation,
                                clientVatNumber: item.attributes.ClientVatNumber,
                                streetAddress: item.attributes.StreetAddress,
                                homePhone: item.attributes.Homephone,
                                idNumber: item.attributes.IDNumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber,
                                representative: item.attributes.Representative,
                                fax: item.attributes.Fax,
                                cellphone: item.attributes.Cellphone,
                                streetSuburb: item.attributes.StreetSuburb,
                                streetCity: item.attributes.StreetCity,
                                streetProvince: item.attributes.StreetProvince,
                                streetCode: item.attributes.StreetCode,
                                postalSuburb: item.attributes.PostalSuburb,
                                postalCity: item.attributes.PostalCity,
                                postalProvince: item.attributes.PostalProvince,
                                postalCode: item.attributes.PostalCode,
                                postalCountry: item.attributes.PostalCountry,
                                streetCountry: item.attributes.StreetCountry,
                                professionalBody: item.attributes.ProfessionalBody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber,
                                groups: []
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(CreateApplicationLocationEcConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                const propertyControl = this.getProperties();
                const propertyIndex = propertyControl.length;
                propertyControl.push(newProperty);
                this.active = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                this.changeDetectorRefs.detectChanges();
                if (owners.length > 0) {
                    RecipientUtils.setRecipients(owners, true, ownersControl);
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            const propertyControl = this.getProperties();
            const propertyIndex = propertyControl.length;
            propertyControl.push(newProperty);
            this.active = propertyControl.length - 1;
            this.updateRequiredFields(propertyIndex);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Electrical connection graphics", true);
        }
        else {
            this.mapComponent.removeGraphicsFromMap("Electrical connection graphics");
        }
    }
    subscribeToClearMapGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.getProperties().clear();
                    this.mapComponent.removeGraphicsFromMap("Electrical connection graphics");
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    syncMapExistingGeometries() {
        const pa = this.getProperties();
        while (pa.controls.length > 0) {
            pa.removeAt(0);
        }
        this.ecApplication.properties.forEach((prop) => {
            pa.push(this.singleFg(prop));
            this.updateRequiredFields(pa.length - 1);
        });
    }
    singleFg(prop) {
        const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100));
        const propertyFoemGroup = new FormGroup({
            id: new FormControl(prop.id),
            applicationId: new FormControl(prop.applicationId),
            erfNo: new FormControl(prop.erfNumber, [Validators.required]),
            subdivision: new FormControl(prop.subdivision, [Validators.required]),
            allotment: new FormControl(prop.allotment, [Validators.required]),
            farmNo: new FormControl(prop.farmNumber, [Validators.required]),
            sgCode: new FormControl(prop.sgCode, [Validators.required]),
            address: new FormControl(prop.address, [Validators.required]),
            centroid: new FormControl(null),
            zones: new FormArray([], [Validators.min(1)]),
            owners: new FormControl(null, [Validators.required]),
            geometry: new FormControl(geom),
            buildingName: new FormControl(prop.buildingName, [Validators.required]),
            floor: new FormControl(prop.floor, [Validators.required]),
        });
        const ownerControl = propertyFoemGroup.get("owners");
        if (this.ecApplication.properties && this.ecApplication.properties.length > 0)
            RecipientUtils.setRecipients(prop.owners, true, ownerControl);
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geom));
        this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
            .subscribe({
            next: (trueCentroidResponse) => {
                propertyFoemGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
            }, error: (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.handleServerErrorMessage(CreateApplicationLocationEcConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
        return propertyFoemGroup;
    }
    subscribeToCheckFormValidity() {
        this.applicationCreateServiceSubscription = this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.propertiesForm && formGroupName === this.propertiesFormGroupName) {
                    this.propertiesForm.markAllAsTouched();
                    this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientService },
        { type: AppControllerService },
        { type: MapService },
        { type: MapTools },
        { type: SelectedApplicationService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationEcComponent = __decorate([
    Component({
        selector: "app-create-application-location-ec",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], CreateApplicationLocationEcComponent);
export { CreateApplicationLocationEcComponent };
